class TouchDetectionService {
    constructor() {
        this.update();
        window.addEventListener("resize", this.update);
    }

    update() {
        document.documentElement.style.setProperty(
            "--w-scrollbar",
            `${window.innerWidth - document.body.clientWidth}px`
        );
    }
}

export default TouchDetectionService;
